export default __webpack_public_path__ + "static/media/DrinkPotion Delayed.c697935b.wav";